<div ngbAccordion [closeOthers]="true" #accordion="ngbAccordion" *ngIf="!loading">
  <div [ngbAccordionItem]="item.id" [collapsed]="false" *ngFor="let item of course?.chapters">
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton>
        <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex align-items-center gap-2">
            <div class="title">{{item.title}}</div>
            <div class="tag tag-dark">{{item.lessons?.length}} {{ 'PANEL.LMS.LESSONS.SESSIONS_COUNT' | translate }}</div>
          </div>
          <div class="more d-flex align-items-center gap-2">
            <div class="d-flex flex-column gap-1">
              <div class="percentage">
                <span> %{{item.percentage | number:'1.0-0'}} </span> {{ 'PANEL.LMS.LESSONS.COMPLETED' | translate }}
              </div>
              <ngb-progressbar type="primary" [value]="item.percentage" />
            </div>
          </div>
          <!-- <div class="more d-flex align-items-center gap-2">
            <div class="d-flex gap-2">
              <svg-icon class="svg-icon" [src]="'/assets/Icons/new/lock.svg'"></svg-icon>
              Lock
            </div>
          </div> -->
        </div>
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>

          <div class="accordion-content">
            <div class="row">
              <div class="col-lg-6">
                <div class="module-description mb-4">
                  <div class="title mb-2">{{ 'PANEL.LMS.LESSONS.MODULE_DESCRIPTION' | translate }}</div>
                  <div class="text">
                    {{item.description}}
                  </div>
                </div>

                <div class="card" *ngIf="item.teachers?.length">
                  <div class="card-header d-flex align-items-center gap-2">
                    <svg-icon class="svg-icon" [src]="'/assets/Icons/new/training.svg'"></svg-icon>
                    {{ 'PANEL.LMS.LESSONS.PRESENTER' | translate }}
                  </div>
                  <div class="card-body d-flex align-items-center justify-content-between"
                    *ngFor="let teacher of item.teachers">
                    <div class="info">
                      <div class="title">{{teacher?.fullname}}</div>
                      <div class="sub">{{teacher.university}}</div>
                      <div class="sub sub-sm">{{teacher?.courseCount}} {{ 'PANEL.LMS.LESSONS.PROGRAMS' | translate }} • {{teacher?.studentCount}} {{ 'PANEL.LMS.LESSONS.LEARNERS' | translate }}
                      </div>
                    </div>
                    <div class="img">
                      <img [src]="teacher?.profileImageUrl ? teacher.profileImageUrl : defaultAvatar"
                        class="avatar avatar-xxxl">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <!-- <div class="video-container">
                  <video controls>
                    <source src="movie.mp4" type="video/mp4">
                    <source src="movie.ogg" type="video/ogg">
                    Your browser does not support the video tag.
                  </video>
                </div> -->
              </div>
            </div>
          </div>


          <hr />


          <ul class="sessions-list m-0 p-0">
            <li class="session-item" *ngFor="let session of item.lessons; let i = index">
              <div class="session-header d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center gap-2">
                    <div class="tag-lg d-flex align-items-center gap-1">
                    <svg-icon src="/assets/Icons/new/book.svg"></svg-icon>
                    {{ 'PANEL.LMS.LESSONS.SESSION' | translate }} {{i+1}}
                  </div>
                  <div class="session-info">
                    <div class="title"> {{session.title}}</div>
                    <!-- <div class="sub">Mark done</div> -->
                  </div>
                </div>

                <div class="more">
                    <a [routerLink]="['session',session.id]" [queryParamsHandling]="'preserve'"
                    class="btn btn-text d-flex align-items-center gap-2">
                    {{ 'PANEL.LMS.LESSONS.VIEW_DETAILS' | translate }}
                    <svg-icon src="/assets/Icons/new/angle-right-green.svg"></svg-icon>
                  </a>
                </div>
              </div>
              <div class="session-body">
                <!-- coming soon -->
                @if (session.assignments?.length) {
                <ul class="assignment-list m-0">
                  <li class="assignment-item" *ngFor="let assignment of session.assignments; let k = index">
                    <div class="d-flex align-items-center gap-2">
                        <div class="tag-lg d-flex align-items-center gap-1">
                        <svg-icon src="/assets/Icons/new/pencil paper.svg"></svg-icon>
                        {{ 'PANEL.LMS.LESSONS.ASSIGNMENT' | translate }} {{k+1}}
                      </div>
                      <div class="assignment-info">

                        <div class="title">{{assignment.title}}
                          <span class="tag tag-light-primary rounded-pill px-2 d-inline-flex align-items-center ms-1"
                            *ngIf="assignment.isSubmitted">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                              xmlns="http://www.w3.org/2000/svg" class="me-1">
                              <g id="check-circle">
                                <path id="check-circle_2"
                                  d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.03 10.2L11.36 14.86C11.22 15.01 11.03 15.08 10.83 15.08C10.64 15.08 10.45 15.01 10.3 14.86L7.97 12.53C7.68 12.24 7.68 11.76 7.97 11.47C8.26 11.18 8.74 11.18 9.03 11.47L10.83 13.27L14.97 9.14001C15.26 8.84001 15.74 8.84001 16.03 9.14001C16.32 9.43001 16.32 9.90001 16.03 10.2Z"
                                  fill="#2C997F" />
                              </g>
                            </svg>

                            {{ 'PANEL.LMS.LESSONS.SUBMITTED' | translate }}
                            {{assignment.submitDate | date:'MMM dd'}}</span>
                        </div>
                        <!-- <div class="sub">Mark done</div> -->
                      </div>
                    </div>
                  </li>
                  <!-- <li class="assignment-item">
                    <div class="d-flex align-items-center gap-2">
                      <div class="tag-lg d-flex align-items-center gap-1">
                        <svg-icon src="/assets/Icons/new/pencil paper.svg"></svg-icon>
                        Assignment 2
                      </div>
                      <div class="assignment-info">
                        <div class="title">Locked until “Label your Microscope” is graded</div>
                      </div>
                    </div>
                  </li> -->
                </ul>
                }
              </div>
            </li>
          </ul>

        </ng-template>
      </div>
    </div>
  </div>
</div>



<ng-container *ngIf="loading">
  <div class="accordion">
    <div class="accordion-item" *ngFor="let item of [1,2,3,4]">
      <h2 class="accordion-header collapsed">
        <button class="accordion-button collapsed">
          <div class="d-flex align-items-center justify-content-between w-100">
            <p-skeleton width="300px"></p-skeleton>
            <p-skeleton width="100px"></p-skeleton>
          </div>
        </button>
      </h2>
    </div>
  </div>
</ng-container>